import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Observable } from 'rxjs';
import { AdicionalProdutoViewModel } from 'src/app/shared/models/produto.model';

@Component({
  selector: 'app-adicionais-produto',
  templateUrl: './adicionais-produto.component.html',
  styleUrls: ['./adicionais-produto.component.scss']
})
export class AdicionaisProdutoComponent {
  @Input() adicionalCtrl!: FormControl;
  @Input() adicionaisFiltrados!: Observable<AdicionalProdutoViewModel[]>;
  @Input() adicionaisAdicionados: AdicionalProdutoViewModel[] = [];
  @Input() desativarAdicionar: boolean = false;
  @Input() desativarPrecoAdicional: boolean = false;

  @Output() addAdicional = new EventEmitter<any>();
  @Output() selectedAdicional = new EventEmitter<MatAutocompleteSelectedEvent>();
  @Output() alterarPrecoAdicional = new EventEmitter<any>();
  @Output() removerAdicional = new EventEmitter<AdicionalProdutoViewModel>();

  @ViewChild('precoInput') precoInput!: ElementRef<HTMLInputElement>;
  @ViewChild('adicionalInput') adicionalInput!: ElementRef<HTMLInputElement>;

  public onAddAdicional(event: any): void {
    this.addAdicional.emit(event);
    if (this.adicionalInput && this.adicionalInput.nativeElement) {
      setTimeout(() => this.adicionalInput.nativeElement.focus(), 150);
    }
  }

  public onSelectedAdicional(event: MatAutocompleteSelectedEvent): void {
    this.selectedAdicional.emit(event);
  }

  public onAlterarPrecoAdicional(event: any): void {
    this.alterarPrecoAdicional.emit(event);
  }

  public onRemoverAdicional(adicional: AdicionalProdutoViewModel): void {
    this.removerAdicional.emit(adicional);
  }

  public limparPrecoInput(): void {
    if (this.precoInput && this.precoInput.nativeElement) {
      this.precoInput.nativeElement.value = '';
    }
  }
}
